import { useParticipant } from '~/composables/api/useParticipant'
import { ParticipantStatus } from '~/types/prisma'

export async function checkPendingInvites(): Promise<'pending' | 'active' | null> {
  const { getMyParticipants } = useParticipant()
  const participants = await getMyParticipants()

  if (!participants?.length) return null

  const hasPending = participants.some(p => p.status === ParticipantStatus.INVITED)
  return hasPending ? 'pending' : 'active'
}
